import { useCallback, useState } from 'react';

export function useAccountingFilters(initialFilters) {
  const [filters, setFilters] = useState(initialFilters);

  const setFilter = useCallback((name, value) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  const resetFilters = useCallback(() => {
    setFilters(initialFilters);
  }, [initialFilters]);

  return {
    filters,
    setFilter,
    resetFilters,
  };
}
